import { ExportIcon } from '@carboncopyco/icons';
import { DropdownItem } from '@carboncopyco/ui';

interface Props {
  onItemClick: () => void;
  isDisabled?: boolean;
}

export const TextExtractionExport: React.FC<Props> = ({
  onItemClick,
  isDisabled,
}) => {
  return (
    <DropdownItem
      label="Export text"
      iconLeft={<ExportIcon size={20} />}
      onClick={onItemClick}
      disabled={isDisabled}
    />
  );
};
